import EmailComposer from '@/components/common/EmailComposer'

export default function AdminSendEmail() {
  return <EmailComposer allowedRecipientRoles={['student', 'teacher', 'admin']} senderRole="admin" />
}
